export type formType = {
  id: null | string;
  rating: null | string;
  mainInstallCode: null | any;
  fishCategoryCode: null | any;
  nearbyDrinkingWaterCatchmentArea: null | any;
  nearbyWaterActivitiesCenter: null | any;
  nearbyMooring: null | any;
  nearbySaltMarsh: null | any;
  nearbyFishingArea: null | any;
  shellfishAreaSurfaceCode: null | any;
  beachSupervised: null | any;
  nearbyShellfishArea: null | any;
  beachLengthCode: null | any;
  nearbyBeach: null | any;
};
export type formCoefficientType = {
  id: null | string;
  rating: null | string;
  mainInstallCode: null | any;
  transferType: null | any;
  distance: null | any;
};

export type formReceivingType = {
  id: string;
  label: string;
  stationLabel: string;
  chemicalStationLabel: string;
  coastline: boolean;
  comment: string;
};

export type formBcParamsType = {
  id: number;
  collectionPoolId: number;
  blackPointCount: number;
  indusSensitive: boolean;
  rainDumpSensitive: boolean;
  h2SDryPeriodStartDate: any;
  h2SDryPeriodEndDate: any;
};

export type Validation = {
  aggravatingFactor: null | any;
  averageTemp: null | any;
  civilEngDegrad: null | any;
  dco: null | any;
  qualiMeasure: null | any;
};

export type TabProps ={
  id: number;
  label: string;
  active: boolean;
}

export const transferTypeMapping = {
  "Ruissellement-infiltration": 1,
  "Cours d’eau": 2,
  Mixte: 3,
  Pluvial: 4,
  Direct: 5,
};

export const distanceMapping = {
  "> 1000": 1,
  "500 < < 1000": 2,
  "100 < < 500": 3,
  "< 100": 4,
};

export const OneToFourInterface = [
  {
    id: 1,
    label: "1",
    automatedTestId: "OneToFourInterface-un",
  },
  {
    id: 2,
    label: "2",
    automatedTestId: "OneToFourInterface-deux",
  },
  {
    id: 3,
    label: "3",
    automatedTestId: "OneToFourInterface-trois",
  },
  {
    id: 4,
    label: "4",
    automatedTestId: "OneToFourInterface-quatre",
  },
];

export const FishFarmingCat = [
  {
    id: 1,
    label: "1",
    checked: 1,
    automatedTestId: "FishFarmingCat-un",
  },
  {
    id: 2,
    label: "2",
    checked: 2,
    automatedTestId: "FishFarmingCat-deux",
  },
  {
    id: 3,
    label: " Non concerné",
    checked: 3,
    automatedTestId: "FishFarmingCat-notConcerned",
  },
];

export const OneTwoInterface = [
  {
    id: 1,
    label: "1",
    automatedTestId: "OneTwoInterface-un",
  },
  {
    id: 2,
    label: "2",
    automatedTestId: "OneTwoInterface-deux",
  },
];

export const YesNoInterface = [
  {
    id: 1,
    label: "Oui",
    checked: true,
    automatedTestId: "presence-oui",
  },
  {
    id: 0,
    label: "Non",
    checked: false,
    automatedTestId: "presence-non",
  },
];

export const LinearInterface = [
  {
    id: 1,
    label: "0",
    checked: 1,
    automatedTestId: "linear-zero",
  },
  {
    id: 2,
    label: "<400",
    checked: 2,
    automatedTestId: "linear-minus",
  },
  {
    id: 3,
    label: ">400",
    checked: 3,
    automatedTestId: "linear-plus",
  },
];

export const ShellfishInterface = [
  {
    id: 1,
    label: "Absence",
    checked: 1,
    automatedTestId: "Shellfish-One",
  },
  {
    id: 2,
    label: "<5k",
    checked: 2,
    automatedTestId: "Shellfish-Two",
  },
  {
    id: 3,
    label: "5k à 10k",
    checked: 3,
    automatedTestId: "Shellfish-Tree",
  },
  {
    id: 4,
    label: ">10k",
    checked: 4,
    automatedTestId: "Shellfish-Four",
  },
];

export const transferType = [
  {
    id: 1,
    label: "Ruissellement-infiltration",
    automatedTestId: "transfer-One",
  },
  {
    id: 2,
    label: "Cours d’eau",
    automatedTestId: "transfer-Two",
  },
  {
    id: 3,
    label: "Mixte",
    automatedTestId: "transfer-Tree",
  },
  {
    id: 4,
    label: "Pluvial",
    automatedTestId: "transfer-Four",
  },
  {
    id: 5,
    label: "Direct",
    automatedTestId: "transfer-Five",
  },
];

export const midDistance = [
  {
    id: 1,
    label: "> 1000",
    value: "> 1000",
    automatedTestId: "midDistance-One",
  },
  {
    id: 2,
    label: "Entre 500 et 1000",
    value: "500 < < 1000",
    automatedTestId: "midDistance-Two",
  },
  {
    id: 3,
    label: "Entre 100 et 500",
    value: "100 < < 500",
    automatedTestId: "midDistance-Tree",
  },
  {
    id: 4,
    label: "A moins de 100",
    value: "< 100",
    automatedTestId: "midDistance-Four",
  },
];